import { Component, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'app-counter-input',
	templateUrl: './counter-input.indra.component.html',
	styleUrls: ['./counter-input.component.css'],
	providers: [
		{
			/**
			 * Custom Control value accessor
			 */
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CounterInputComponent),
			multi: true
		}
	],
	host: {
		class: 'counter-input'
	}
})
export class CounterInputComponent implements ControlValueAccessor {

	_counterValue: number;
	@Input() label;
	@Input() description;
	@Input() formControlName;
	@Input() setIncrementToDisable;
	@Input() setDecrementToDisable;
	@Input() passengerType;
	@Input() layoutFormat: 'trip-finder' | 'mini-ibe' | 'stopovers' = 'mini-ibe';
	@Output() valueIncrement = new EventEmitter();
	@Output() valueDecrement = new EventEmitter();

	typePassengersAriaAlert = '';

	/**
	 * minimum and maximum values for _counterValue
	 * defaults to lowest integer and highest integer
	 */
	@Input() min: number;
	@Input() max: number;

	// required for ControlValueAccessor
	propagateChange = (_: any) => { };

	constructor() {
	}

	/**
	 * counter value getter
	 * Use on template
	 */
	get counterValue(): number {
		return this._counterValue;
	}

	/**
	 * Counter Value setter
	 * guards against overflow and underflow
	 * Propagates changes to Parent throught formcontrol
	 */
	set counterValue(val) {
		val = +val;

		if (val < this.min) {
			this._counterValue = this.min;
		} else {
			this._counterValue = val;
		}
		this.propagateChange(this._counterValue);
		this.typePassengersAriaAlert = this._counterValue + ' ' + this.label + ' selected.';
	}

	/**
	 * counter value incrementer
	 * Use on template
	 */
	increment() {
		if (this.counterValue < this.max) {
			this.counterValue++;
		}

		this.valueIncrement.emit(this.formControlName);
	}

	/**
	 * counter value incrementer
	 * Use on template
	 */
	decrement() {
		if (this.counterValue > this.min) {
			this.counterValue--;
		}

		this.valueDecrement.emit(this.formControlName);
	}

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: any): void { }

	writeValue(value: any) {
		this.counterValue = value;
	}

	INDRA_disableIncrement(type: string) {
		if (this.setIncrementToDisable === 'enable10Days' && this.counterValue == this.max) {
			return true;
		} else {
			if (this.counterValue == this.counterValue + this.max) {
				return true;
			}
			if (this.setIncrementToDisable[type]) {
				return true;
			}
		}

		return false;
	}

	INDRA_disableDecrement(type: string) {
		if (this.counterValue == this.min) {
			return true;
		}
		if (this.setDecrementToDisable[type]) {
			return true;
		}
		return false;
	}
}
